/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ApiError } from './ApiError'
import { ApiErrorFromJSON, ApiErrorFromJSONTyped, ApiErrorToJSON } from './ApiError'

/**
 *
 * @export
 * @interface EnvelopedAdditinalWorkCreate
 */
export interface EnvelopedAdditinalWorkCreate {
  /**
   *
   * @type {any}
   * @memberof EnvelopedAdditinalWorkCreate
   */
  body: any | null
  /**
   *
   * @type {Array<ApiError>}
   * @memberof EnvelopedAdditinalWorkCreate
   */
  errors: Array<ApiError>
}

/**
 * Check if a given object implements the EnvelopedAdditinalWorkCreate interface.
 */
export function instanceOfEnvelopedAdditinalWorkCreate(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'body' in value
  isInstance = isInstance && 'errors' in value

  return isInstance
}

export function EnvelopedAdditinalWorkCreateFromJSON(json: any): EnvelopedAdditinalWorkCreate {
  return EnvelopedAdditinalWorkCreateFromJSONTyped(json, false)
}

export function EnvelopedAdditinalWorkCreateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnvelopedAdditinalWorkCreate {
  if (json === undefined || json === null) {
    return json
  }
  return {
    body: json['body'],
    errors: (json['errors'] as Array<any>).map(ApiErrorFromJSON),
  }
}

export function EnvelopedAdditinalWorkCreateToJSON(
  value?: EnvelopedAdditinalWorkCreate | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    body: value.body,
    errors: (value.errors as Array<any>).map(ApiErrorToJSON),
  }
}
